const baseLightTheme = {
  palette: {
    primary: {
      main: "#e94823",
      light: "#fce2dc",
      ultraLight: "#fff8f7ff",
      dark: "#b73112",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#5DB0E6",
      light: "#9DD7F2",
      extraLight: "#C3E7F7",
      ultraLight: "#e9f6fcff",
      dark: "#1F88D2",
      contrastText: "#ffffff",
    },
    success: {
      main: "#34C759",
      light: "#E6F9ED",
      dark: "#248A3D",
      contrastText: "#ffffff",
    },
    info: {
      main: "#007AFF",
      light: "#E5F0FF",
      dark: "#0040DD",
      contrastText: "#ffffff",
    },
    error: {
      main: "#FF3B30",
      light: "#FFE6E3",
      dark: "#C60B00",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#FF9500",
      light: "#FFF2E0",
      dark: "#C76A00",
      contrastText: "#ffffff",
    },
    grey: {
      100: "#F8FAFB",
      200: "#F1F3F5",
      250: "#E9ECF0",
      300: "#E2E5EA",
      350: "#A5A4A0",
      400: "#868E96",
      500: "#64707D",
      600: "#2B3240",
    },
    text: {
      primary: "#111827",
      secondary: "#6B7280",
      disabled: "#9CA3AF",
      hint: "#D1D5DB",
    },
    action: {
      active: "#6B7280",
      hover: "rgba(75, 85, 99, 0.04)",
      selected: "rgba(75, 85, 99, 0.06)",
      disabled: "rgba(0, 0, 0, 0.26)",
      disabledBackground: "rgba(0, 0, 0, 0.08)",
      focus: "rgba(75, 85, 99, 0.10)",
      hoverOpacity: 0.04,
      selectedOpacity: 0.06,
      disabledOpacity: 0.38,
      focusOpacity: 0.1,
      activatedOpacity: 0.1,
    },
    divider: "#E5E7EB",
    border: "#E5E7EB",
    background: {
      default: "#ffffff",
      dark: "#FAFAFA",
      paper: "#ffffff",
      invert: "#1A2129",
      accent: "#000000",
      accentHover: "#0F161C",
      highlight: "#F9FAFB",
    },
    brand: {
      facebook: "#3b5998",
      twitter: "#1da1f2",
      linkedin: "#2967B3",
      google: "#db4437",
    },
    hoverBrand: {
      facebook: "#2d4373",
      twitter: "#0b7bc5",
      linkedin: "#1d4a7e",
      google: "#c1351d",
    },
  },
};

const baseDarkTheme = {
  palette: {
    primary: {
      main: "#FA896B",
      light: "#402E32",
      ultraLight: "#5A3E3A",
      dark: "#f86037",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#1F88D2",
      light: "#104868",
      ultraLight: "#3A6D9D",
      dark: "#0060A0",
      contrastText: "#ffffff",
    },
    success: {
      main: "#30D158",
      light: "#1C3A2E",
      dark: "#248A3D",
      contrastText: "#000000",
    },
    info: {
      main: "#0A84FF",
      light: "#0A1E3D",
      dark: "#0040DD",
      contrastText: "#000000",
    },
    error: {
      main: "#FF453A",
      light: "#3B1210",
      dark: "#C60B00",
      contrastText: "#000000",
    },
    warning: {
      main: "#FFD60A",
      light: "#3A2E00",
      dark: "#C76A00",
      contrastText: "#000000",
    },
    grey: {
      100: "#1E2733",
      150: "#253140",
      200: "#2C3A4C",
      250: "#374559",
      300: "#435166",
      350: "#5A6A85",
      400: "#7C8FAC",
      500: "#A0AEBF",
      600: "#E4E9EF",
    },
    text: {
      primary: "#F1F3F5",
      secondary: "#A0AEC0",
      disabled: "#5A6478",
      hint: "#6B7688",
    },
    action: {
      active: "#FFFFFF",
      hover: "rgba(255, 255, 255, 0.06)",
      selected: "rgba(255, 255, 255, 0.10)",
      disabled: "rgba(255, 255, 255, 0.26)",
      disabledBackground: "rgba(255, 255, 255, 0.08)",
      focus: "rgba(255, 255, 255, 0.10)",
      hoverOpacity: 0.06,
      selectedOpacity: 0.1,
      disabledOpacity: 0.38,
      focusOpacity: 0.1,
      activatedOpacity: 0.16,
    },
    divider: "#2D3748",
    border: "#2D3748",
    background: {
      default: "#0F1419",
      dark: "#0A0E13",
      paper: "#171E27",
      invert: "#fafbfb",
      accent: "#e94823",
      accentHover: "#d73d1a",
      highlight: "#1A2232",
    },
    brand: {
      facebook: "#3b5998",
      twitter: "#1da1f2",
      linkedin: "#2967B3",
      google: "#db4437",
    },
    hoverBrand: {
      facebook: "#2d4373",
      twitter: "#0b7bc5",
      linkedin: "#1d4a7e",
      google: "#c1351d",
    },
  },
};

export { baseDarkTheme, baseLightTheme };
